import { Popconfirm, Table, Tag } from "antd";
import React from "react";
import { Card, CardBody } from "reactstrap";
import {
  deleteInventoryCustomer,
  fetchInventoryCustomers,
} from "../../../../../api/inventory.api";
import styles from "./styles.module.scss";
import AddCustomerDrawer from "./form";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

const InventoryCustomer = () => {
  const [customers, setCustomers] = React.useState([]);
  const [showCustomerDrawer, setShowCustomerDrawer] = React.useState(false);
  const [editItem, setEditItem] = React.useState(null);

  const getCustomers = React.useCallback(async () => {
    try {
      const customers = await fetchInventoryCustomers();
      setCustomers(customers);
    } catch (error) {
      console.log(error);
    }
  }, []);

  React.useEffect(() => {
    getCustomers();
  }, [getCustomers]);

  const tableColumns = React.useMemo(() => {
    const columns = [
      {
        key: "id",
        title: "S. No.",
        dataIndex: "id",
        width: 70,
        fixed: "left",
      },
      {
        key: "customer_name",
        title: "Customer Name",
        dataIndex: "customer_name",
        width: 165,
        fixed: "left",
      },
      {
        key: "contact",
        title: "Contact",
        dataIndex: "contact",
        width: 165,
        fixed: "left",
      },
      {
        key: "email",
        title: "Email",
        dataIndex: "email",
        width: 165,
      },
      {
        key: "billing_address",
        title: "Billing Address",
        dataIndex: "billing_address",
        width: 300,
      },
      {
        key: "billing_city",
        title: "Billing City",
        dataIndex: "billing_city",
        width: 165,
      },
      {
        key: "billing_state",
        title: "Billing State",
        dataIndex: "billing_state",
        width: 165,
      },
      {
        key: "billing_country",
        title: "Billing Country",
        dataIndex: "billing_country",
        width: 165,
      },
      {
        key: "billing_pincode",
        title: "Billing Pincode",
        dataIndex: "billing_pincode",
        width: 150,
      },
      {
        key: "shipping_address",
        title: "Shipping Address",
        dataIndex: "shipping_address",
        width: 300,
      },
      {
        key: "shipping_city",
        title: "Shipping City",
        dataIndex: "shipping_city",
        width: 165,
      },
      {
        key: "shipping_state",
        title: "Shipping State",
        dataIndex: "shipping_state",
        width: 165,
      },
      {
        key: "shipping_country",
        title: "Shipping Country",
        dataIndex: "shipping_country",
        width: 165,
      },
      {
        key: "shipping_pincode",
        title: "Shipping Pincode",
        dataIndex: "shipping_pincode",
        width: 150,
      },
      {
        key: "gstin",
        title: "GSTIN",
        dataIndex: "gstin",
        width: 165,
      },
      {
        key: "actions",
        title: "Actions",
        width: 100,
        fixed: "right",
        render: (item) => {
          return (
            <div className={styles.actions}>
              <Tag
                color="blue"
                onClick={() => {
                  setEditItem(item);
                  setShowCustomerDrawer(true);
                }}
              >
                <EditOutlined />
              </Tag>
              <Popconfirm
                onConfirm={async () => {
                  await deleteInventoryCustomer(item.id);
                  getCustomers();
                }}
                title="Are you sure to delete this customer?"
              >
                <Tag color="red">
                  <DeleteOutlined />
                </Tag>
              </Popconfirm>
            </div>
          );
        },
      },
    ];

    return columns;
  }, [getCustomers]);

  return (
    <div className={styles.container}>
      <AddCustomerDrawer
        onClose={() => setShowCustomerDrawer(false)}
        open={showCustomerDrawer}
        refresh={getCustomers}
        edit={!!editItem}
        item={editItem}
      />
      <div>
        <Card>
          <CardBody>
            <div className={styles.header}>
              <h5>Customer</h5>
              <div className={styles.actions}>
                <Tag color="blue" onClick={() => setShowCustomerDrawer(true)}>
                  Add Customer
                </Tag>
              </div>
            </div>
            <div className={styles.categories}>
              <Table
                columns={tableColumns}
                dataSource={customers}
                pagination={false}
                scroll={{ x: "max-content" }}
              />
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default InventoryCustomer;
